module.exports = __webpack_public_path__ + "img/dorinte.bd96b955.png";